import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppState } from "../../context/AppStateContext";
import { useConversations } from "../../hooks/queries";
import { Empty } from "../ui/Badges";
import { AutomationRules } from "./AutomationRules";
import { ChatList } from "./ChatList";
import { ChatThread } from "./ChatThread";
import { TemplateEditor } from "./TemplateEditor";

export function WhatsAppPanel() {
  const { t } = useTranslation();
  const { chatGuardianId } = useAppState();
  const { data: conversations = [] } = useConversations();
  const [selected, setSelected] = useState<string | null>(chatGuardianId);

  useEffect(() => {
    if (chatGuardianId) setSelected(chatGuardianId);
  }, [chatGuardianId]);
  useEffect(() => {
    if (!selected && conversations[0]) setSelected(conversations[0].guardian.id);
  }, [conversations, selected]);

  const current = conversations.find((c) => c.guardian.id === selected);

  return (
    <div className="space-y-5">
      <div className="card overflow-hidden">
        <div className="flex items-center gap-3 border-b border-gray-100 bg-white px-5 py-3.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-500 text-lg text-white" aria-hidden>💬</div>
          <div>
            <h1 className="text-base font-black tracking-tight">{t("whatsapp.title")}</h1>
            <p className="text-[11px] text-gray-500">{t("whatsapp.subtitle")}</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-12">
          <div className="border-gray-100 md:col-span-5 md:border-e">
            <ChatList conversations={conversations} selectedId={selected} onSelect={setSelected} />
          </div>
          <div className="md:col-span-7">
            {current ? <ChatThread key={current.guardian.id} conversation={current} /> : <div className="p-6"><Empty>{t("whatsapp.pickChat")}</Empty></div>}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <AutomationRules />
        <TemplateEditor />
      </div>
    </div>
  );
}
